export default __webpack_public_path__ + "static/media/americanExpress.821543a9.svg";